import { Api, IApiResponse } from '../api';
import { UserLocation } from '../models';

const getAll = (): Promise<IApiResponse<UserLocation[]>> => Api.get('Locations');

export { getAll };
